import { MyIcon } from 'ccs-ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { CheckboxTreeProps, TreeNode } from '../utilities/TypeDefs';
import classes from './CheckBoxTree.module.scss';

export const CheckBoxTree: React.FC<CheckboxTreeProps> = ({
  nodes,
  checkedNodes,
  onCheckChange,
  duplicates,
  disabledCheckBox
}: CheckboxTreeProps) => {
  const { t: translate } = useTranslation();
  const [expanded, setExpanded] = useState<string[]>([]);

  const handleExpand = (nodeId: string) => {
    const isExpanded = expanded.includes(nodeId);
    let newExpandedNodes;

    if (isExpanded) {
      newExpandedNodes = expanded.filter((value) => value !== nodeId);
    } else {
      newExpandedNodes = [...expanded, nodeId];
    }

    setExpanded(newExpandedNodes);
  };

  const renderTreeNodes = (nodes: TreeNode[]) => nodes.map((node) => (
    <div key={node.value}>
      <div className={classes['tree-options']}>
        {
          node.children && node.children.length > 0 && (
            <button onClick={() => handleExpand(node.value)} type="button" className={classes['tree-button-icons']} data-testid="view-child-nodes" aria-label="Expand / Collapse">
              {expanded.includes(node.value) ? <i className="fa-solid fa-chevron-down" /> : <i className="fa-solid fa-chevron-right" />}
            </button>
          )
        }
        <input
          type="checkbox"
          checked={checkedNodes.includes(node.value)}
          id={node.value}
          onChange={!disabledCheckBox ? (ev) => onCheckChange(node.value, ev.currentTarget.checked) : undefined}
          className={!node.children || node.children?.length === 0 ? classes['no-child-option'] : ''}
          data-testid="check-payload"
        />
        <label htmlFor={node.value} className={classes['option-label']}>{node.label}</label>
        {/* Duplicate error icon display commented out to bypass duplicate restriction */}
        <span title={String(translate('payload_transformation_component.payload_err_msg'))} data-testid="duplicate-field-check">
          {duplicates.includes(node.value) && checkedNodes.includes(node.value) && <MyIcon name="xCircleIcon" className={classes['error-icon']} />}
        </span>
      </div>

      {
        expanded.includes(node.value) && node.children && node.children.length > 0 && (
          <div className={classes['expanded-options']}>{renderTreeNodes(node.children)}</div>
        )
      }
    </div>
  ));

  return <div>{renderTreeNodes(nodes)}</div>;
};
